var app = angular.module('gymsystem.util');
app.controller('EInvoiceAddCtrl', ['$scope', 'options', 'server', '$controller', '$filter', '$modal', 'Data', 'util', function ($scope, options, server, $controller, $filter, $modal, Data, util) {
        $controller('AddCtrl', { $scope: $scope });
        var customerId = options.customer.id;
        var getStatus = function () {
            if ($scope.item && $scope.item.status) {
                if ($scope.item.status === 'pending')
                    return $filter('translate')('EINVOICE_SENT');
                if ($scope.item.status === 'ready')
                    return $filter('translate')('EINVOICE_APPROVED');
                return $scope.item.status;
            }
            return $filter('translate')('EINVOICE_NOT_APPROVED');
        };
        var statusClass = function () {
            return { 'pending': 'alert-warning', 'ready': 'alert-success' }[$scope.item && $scope.item.status] || 'alert-info';
        };
        var validatePeppol = {
            badValue: function (modelValue, viewValue) {
                return !viewValue || viewValue.match(/^(0007|0088):\d+/);
            }
        };
        $scope.fields = [
            { title: 'Status', type: 'label', getClass: statusClass, getValue: getStatus, visible: getStatus },
            { name: 'contact_name', title: 'Contact name', type: 'text', required: true },
            { name: 'peppol', title: 'Peppol-ID', type: 'text', required: false, change: onChangePeppol, validator: validatePeppol },
            { name: 'company_number', title: 'Corporate identity', type: 'corporateIdentity', required: false, unique: false },
            { name: 'gln', title: 'GLN', type: 'number', required: false, helpText: 'EINVOICE_GLN_INFO' },
            { name: 'bg_number', title: 'BG-account', type: 'bankgiroNumber', required: false },
            { name: 'reference_number', title: 'Reference number', type: 'text', required: false }
        ];
        var fieldMap = $scope.fields.reduce(function (map, field) { return (map[field.name] = field, map); }, {});
        function onChangePeppol() {
            // 0007:XXXXXXXXXX (svenskt organisationsnummer)
            // 0088: YYYYYYYYYYYYY (GLN nummer)    
            var value = fieldMap.peppol.value || '';
            fieldMap.company_number.readonly = value.startsWith('0007:');
            fieldMap.company_number.required = !fieldMap.company_number.readonly;
            fieldMap.gln.readonly = value.startsWith('0088:');
        }
        Data.load('user', customerId).then(function (customer) {
            $scope.item = {};
            if (customer.einvoice) {
                $scope.item = customer.einvoice;
                util.setValues($scope.fields, $scope.item, { callChange: true });
            }
            else {
                util.setValues($scope.fields, {
                    contact_name: customer.xf.Ansvarig || '',
                    company_number: customer.personalCodeNumber || null
                }, { callChange: true });
            }
        });
        $scope.submit = function () {
            $scope.loadingStatus = { loading: true };
            var data = $scope.getSubmitItem();
            data['customer_id'] = customerId;
            server.post2('/api/einvoice/add', data, { successAlert: 'Saved', errorAlert: 'Failed' }).then(function () {
                $modal.open({
                    templateUrl: 'views/infomodal.html',
                    controller: 'ModalCtrl',
                    resolve: {
                        options: function () {
                            return { title: 'EINVOICE_SENT', content: 'EINVOICE_SENT_INFO' };
                        }
                    }
                }).result.then($scope.$close, $scope.$close);
            })["finally"](function () { return $scope.loadingStatus = null; });
        };
    }]);
